import { useTranslations } from '../i18n';

export function PrivacyPage() {
  const { t } = useTranslations();

  const privacy = t('privacy', {}) as {
    title: string;
    intro: string;
    sections: {
      title: string;
      paragraphs: string[];
      listTitle?: string;
      bullets?: string[];
    }[];
    footer: {
      lastUpdated: string;
      contactIntro: string;
      contactEmail: string;
      contactDetails?: string;
    };
  };

  return (
    <div className="mx-auto max-w-4xl space-y-12 px-6 py-16">
      <header className="space-y-4">
        <h1 className="text-4xl font-heading text-[var(--color-text-primary)]">{privacy.title}</h1>
        <p className="text-base text-[var(--color-text-primary)]/75">{privacy.intro}</p>
      </header>

      <div className="space-y-6">
        {privacy.sections.map((section) => (
          <section key={section.title} className="glass-surface glass-panel space-y-4">
            <h2 className="text-2xl font-heading text-[var(--color-text-primary)]">{section.title}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph} className="text-sm text-[var(--color-text-primary)]/75">
                {paragraph}
              </p>
            ))}
            {section.bullets?.length ? (
              <div className="space-y-2">
                {section.listTitle ? (
                  <h3 className="text-xs font-semibold uppercase tracking-[0.32em] text-[var(--color-text-primary)]/60">
                    {section.listTitle}
                  </h3>
                ) : null}
                <ul className="space-y-2 text-sm text-[var(--color-text-primary)]/75">
                  {section.bullets.map((bullet) => (
                    <li key={bullet} className="rounded-everbranch-sm bg-[var(--color-bg-primary)]/60 px-4 py-2">
                      • {bullet}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </section>
        ))}
      </div>

      <footer className="glass-surface glass-panel space-y-2 text-sm text-[var(--color-text-primary)]/70">
        <p>{privacy.footer.lastUpdated}</p>
        <p>
          {privacy.footer.contactIntro}{' '}
          <a href={`mailto:${privacy.footer.contactEmail}`} className="text-evergreen">
            {privacy.footer.contactEmail}
          </a>
          {privacy.footer.contactDetails ? ` ${privacy.footer.contactDetails}` : ''}
        </p>
      </footer>
    </div>
  );
}
